import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserById } from "../../services/services";

export const getUserProfileDetails = createAsyncThunk(
  "getUserProfile",
  async (userId) => {
    try {
      const request = await getUserById(userId);
      const response = await request.data;
      return response;
    } catch (error) {
      console.log(error);
    }
  }
);

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState: {
    result: null,
    message: null,
    status: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getUserProfileDetails.fulfilled, (state, action) => {
      state.result = action.payload;
      state.message = "success";
      state.status = 200;
    });
    builder.addCase(getUserProfileDetails.pending, (state, action) => {});
    builder.addCase(getUserProfileDetails.rejected, (state, action) => {
      state.status = 400;
      state.message = action.error.message;
    });
  },
});

export default userProfileSlice.reducer;
